import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import './App.css';

// Pages & Components
import Login from './components/Login/Login';
import AdminLayout from './components/Layouts/AdminLayout';
import Dashboard from './components/Dashboard';
import VendorList from './components/VendorList/VendorList';
import CategoryManager from './components/CategoryManager/categoryManager';
import CreateAdmin from './components/CreateAdmin/CreateAdmin';
import AddItemForm from './components/ItemAdd/AddItemForm';
import AdminTasks from './components/AdminTasks/AdminTasks';
import UserManagement from './components/UserManagement/UserManagement';
import UserOrderList from './components/OrderlistbyUser/UserOrderList';
import UserTaskList from './components/UserManagement/UserTaskList';
import TaskDetailScreen from './components/UserManagement/TaskDetailScreen';
import UsersWithSOS from './components/Sosuser/UsersWithSOS';
import UserTransactionHistory from './components/UserTransactionHistory/UserTransactionHistory';
import UserList from './components/UserTransactionHistory/UserList';
import VendorManager from './components/VendorManager/VendorManager';
import VendorOrdersScreen from './components/VendorManager/VendorOrdersScreen';
import CategoryManageritem from './components/CategoryManager/categoryManageritem';
import SpinAdmin from './components/SpinScreen/SpinAdmin';
import AdminDashboard from './components/Videoapi/Admindashboard ';
import AdminCategories from './components/Videoapi/Admincategories';
import AdminVideos from './components/Videoapi/Adminvideos';
import AdminPlans from './components/Videoapi/Adminplans';

// Protected Route — redirects to /login with the original URL saved
// After login, user is sent back to the page they tried to open
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) return <div className="loading">Loading...</div>;

  if (!isAuthenticated) {
    // Save the attempted URL so Login can redirect back after auth
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

function App() {
  return (
    <div className="App">
      <Routes>
        {/* Public */}
        <Route path="/login" element={<Login />} />

        {/* Protected Admin Routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="registerlist" element={<VendorList />} />
          <Route path="category" element={<CategoryManager />} />
          <Route path="category-items" element={<CategoryManageritem />} />
          <Route path="create" element={<CreateAdmin />} />
          <Route path="item" element={<AddItemForm />} />
          <Route path="task" element={<AdminTasks />} />
          <Route path="usertask" element={<UserTaskList />} />
          <Route path="usertasks/:userId" element={<TaskDetailScreen />} />
          <Route path="user" element={<UserManagement />} />
          <Route path="sosuser" element={<UsersWithSOS />} />
          <Route path="order" element={<UserOrderList />} />
          <Route path="users" element={<UserList />} />
          <Route path="user/:userId/wallet-history" element={<UserTransactionHistory />} />
          <Route path="vendor" element={<VendorManager />} />
          <Route path="vendororder" element={<VendorOrdersScreen />} />
          <Route path="spin" element={<SpinAdmin />} />
          <Route path="adminvideo" element={<AdminDashboard />} />
          <Route path="admincategory" element={<AdminCategories />} />
          <Route path="adminvideos" element={<AdminVideos />} />
          <Route path="adminplans" element={<AdminPlans />} />
        </Route>

        {/* Catch-all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default App;